export const InputEmail = ({ setEmail }: { setEmail: (email: string) => void }) => {
  return (
    <div className="mt-4 flex w-full flex-col whitespace-nowrap">
      <div className="text-glyphs-shade text-xs leading-none font-semibold tracking-wide">
        メールアドレス
      </div>
      <input
        required
        className="border-border text-glyphs-normal focus:border-active mt-2 min-h-[40px] w-full flex-1 shrink gap-2 self-stretch rounded-sm border border-1 bg-white px-4 py-2.5 text-base leading-snug tracking-wider focus:border-1"
        name="email"
        placeholder="example@example.com"
        type="email"
        onChange={(e) => setEmail(e.target.value)}
      />
    </div>
  );
};
